// Telegram UI styles first, so our Tailwind layer can override them.
import '@telegram-apps/telegram-ui/dist/styles.css'

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { retrieveLaunchParams } from '@tma.js/sdk-react'

import 'shared/lib/sentry'
import { init } from 'shared/lib/telegram'
import { isTelegram } from 'shared/lib/telegram/platform'
import { retrieveTelegramUserId } from 'shared/lib/telegram/identity'
import { bootstrapCachedAuth } from 'shared/lib/auth/session'
import './index.css'

// Mock the Telegram environment when running outside Telegram (dev only).
import 'shared/lib/telegram/mock-env'

import App from './App.tsx'

const root = createRoot(document.getElementById('root')!)

if (isTelegram) {
	try {
		const launchParams = retrieveLaunchParams()
		const { tgWebAppPlatform: platform } = launchParams
		const debug =
			(launchParams.tgWebAppStartParam || '').includes('debug') ||
			import.meta.env.DEV

		await init({
			debug,
			mockForMacOS: platform === 'macos',
		})
	} catch (e) {
		console.error('[telegram] init failed', e)
	}
}

const telegramId = isTelegram ? retrieveTelegramUserId() : null
bootstrapCachedAuth(
	isTelegram ? 'telegram' : 'browser-admin',
	telegramId ?? undefined,
)

root.render(
	<StrictMode>
		<App />
	</StrictMode>,
)
